import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { IconArrowRight } from "../components/Icons";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you are looking for does not exist or has been moved."
      />

      <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary via-primary-light to-secondary">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-8xl sm:text-9xl font-bold text-white/20 mb-4">
            404
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h1>
          <p className="text-white/70 text-lg mb-10 leading-relaxed">
            The page you are looking for does not exist or has been moved.
            Let us get you back on track.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-white text-primary font-semibold px-8 py-4 rounded-xl hover:bg-gray-100 transition-all duration-300 hover:shadow-xl"
          >
            Back to Home
            <IconArrowRight size={18} />
          </Link>
        </div>
      </section>
    </>
  );
}
